import { render, staticRenderFns } from "./Unauthorized.vue?vue&type=template&id=5527a38b&scoped=true"
import script from "./Unauthorized.vue?vue&type=script&lang=js"
export * from "./Unauthorized.vue?vue&type=script&lang=js"
import style0 from "./Unauthorized.vue?vue&type=style&index=0&id=5527a38b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5527a38b",
  null
  
)

export default component.exports